import { render, staticRenderFns } from "./ghTablePage.vue?vue&type=template&id=73f0ab2c&scoped=true&"
import script from "./ghTablePage.vue?vue&type=script&lang=js&"
export * from "./ghTablePage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73f0ab2c",
  null
  
)

export default component.exports